import { ALL_CHANNEL_KEYS } from "../containers/CategoryDataUtils";

const channelKeys = ALL_CHANNEL_KEYS;

export default {
  channelKeys,
};
